module.exports = __webpack_public_path__ + "static/media/poppins-500.f346aa98.ttf";